module.exports = __webpack_public_path__ + "static/img/cj05.3bb436f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj05.png
// module id = 149
// module chunks = 0